module.exports = __webpack_public_path__ + "img/help-icon.da3f9869.svg";